
// @ts-nocheck


export const localeCodes =  [
  "en",
  "en-ca",
  "en-co",
  "es-co",
  "en-cr",
  "es-cr",
  "en-es",
  "es",
  "es-es",
  "en-ge",
  "en-gb",
  "en-us",
  "en-hk",
  "en-hu",
  "hu-hu",
  "en-in",
  "en-ie",
  "en-au",
  "en-pa",
  "es-pa",
  "en-pe",
  "es-pe",
  "en-pl",
  "pl-pl",
  "en-pt",
  "pt-pt",
  "en-ro",
  "en-za",
  "en-ae",
  "en-sa",
  "en-om",
  "en-kw",
  "en-bh",
  "en-qa",
  "en-ke",
  "en-ng"
]

export const localeMessages = {
  "en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-GB.json", load: () => import("../lang/en-GB.json" /* webpackChunkName: "locale__data_lang_en_GB_json" */), cache: true }],
  "en-ca": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-CA.json", load: () => import("../lang/en-CA.json" /* webpackChunkName: "locale__data_lang_en_CA_json" */), cache: true }],
  "en-co": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-CO.json", load: () => import("../lang/en-CO.json" /* webpackChunkName: "locale__data_lang_en_CO_json" */), cache: true }],
  "es-co": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__data_lang_es_json" */), cache: true },
{ key: "../lang/es-CO.json", load: () => import("../lang/es-CO.json" /* webpackChunkName: "locale__data_lang_es_CO_json" */), cache: true }],
  "en-cr": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-CR.json", load: () => import("../lang/en-CR.json" /* webpackChunkName: "locale__data_lang_en_CR_json" */), cache: true }],
  "es-cr": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__data_lang_es_json" */), cache: true },
{ key: "../lang/es-CR.json", load: () => import("../lang/es-CR.json" /* webpackChunkName: "locale__data_lang_es_CR_json" */), cache: true }],
  "en-es": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-ES.json", load: () => import("../lang/en-ES.json" /* webpackChunkName: "locale__data_lang_en_ES_json" */), cache: true }],
  "es": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__data_lang_es_json" */), cache: true }],
  "es-es": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__data_lang_es_json" */), cache: true }],
  "en-ge": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-GE.json", load: () => import("../lang/en-GE.json" /* webpackChunkName: "locale__data_lang_en_GE_json" */), cache: true }],
  "en-gb": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-GB.json", load: () => import("../lang/en-GB.json" /* webpackChunkName: "locale__data_lang_en_GB_json" */), cache: true }],
  "en-us": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-US.json", load: () => import("../lang/en-US.json" /* webpackChunkName: "locale__data_lang_en_US_json" */), cache: true }],
  "en-hk": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-HK.json", load: () => import("../lang/en-HK.json" /* webpackChunkName: "locale__data_lang_en_HK_json" */), cache: true }],
  "en-hu": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-HU.json", load: () => import("../lang/en-HU.json" /* webpackChunkName: "locale__data_lang_en_HU_json" */), cache: true }],
  "hu-hu": [{ key: "../lang/hu.json", load: () => import("../lang/hu.json" /* webpackChunkName: "locale__data_lang_hu_json" */), cache: true }],
  "en-in": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-IN.json", load: () => import("../lang/en-IN.json" /* webpackChunkName: "locale__data_lang_en_IN_json" */), cache: true }],
  "en-ie": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-IE.json", load: () => import("../lang/en-IE.json" /* webpackChunkName: "locale__data_lang_en_IE_json" */), cache: true }],
  "en-au": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-AU.json", load: () => import("../lang/en-AU.json" /* webpackChunkName: "locale__data_lang_en_AU_json" */), cache: true }],
  "en-pa": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-PA.json", load: () => import("../lang/en-PA.json" /* webpackChunkName: "locale__data_lang_en_PA_json" */), cache: true }],
  "es-pa": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__data_lang_es_json" */), cache: true },
{ key: "../lang/es-PA.json", load: () => import("../lang/es-PA.json" /* webpackChunkName: "locale__data_lang_es_PA_json" */), cache: true }],
  "en-pe": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-PE.json", load: () => import("../lang/en-PE.json" /* webpackChunkName: "locale__data_lang_en_PE_json" */), cache: true }],
  "es-pe": [{ key: "../lang/es.json", load: () => import("../lang/es.json" /* webpackChunkName: "locale__data_lang_es_json" */), cache: true },
{ key: "../lang/es-PE.json", load: () => import("../lang/es-PE.json" /* webpackChunkName: "locale__data_lang_es_PE_json" */), cache: true }],
  "en-pl": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-PL.json", load: () => import("../lang/en-PL.json" /* webpackChunkName: "locale__data_lang_en_PL_json" */), cache: true }],
  "pl-pl": [{ key: "../lang/pl.json", load: () => import("../lang/pl.json" /* webpackChunkName: "locale__data_lang_pl_json" */), cache: true }],
  "en-pt": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-PT.json", load: () => import("../lang/en-PT.json" /* webpackChunkName: "locale__data_lang_en_PT_json" */), cache: true }],
  "pt-pt": [{ key: "../lang/pt.json", load: () => import("../lang/pt.json" /* webpackChunkName: "locale__data_lang_pt_json" */), cache: true }],
  "en-ro": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-RO.json", load: () => import("../lang/en-RO.json" /* webpackChunkName: "locale__data_lang_en_RO_json" */), cache: true }],
  "en-za": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-ZA.json", load: () => import("../lang/en-ZA.json" /* webpackChunkName: "locale__data_lang_en_ZA_json" */), cache: true }],
  "en-ae": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-AE.json", load: () => import("../lang/en-AE.json" /* webpackChunkName: "locale__data_lang_en_AE_json" */), cache: true }],
  "en-sa": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-SA.json", load: () => import("../lang/en-SA.json" /* webpackChunkName: "locale__data_lang_en_SA_json" */), cache: true }],
  "en-om": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-OM.json", load: () => import("../lang/en-OM.json" /* webpackChunkName: "locale__data_lang_en_OM_json" */), cache: true }],
  "en-kw": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-KW.json", load: () => import("../lang/en-KW.json" /* webpackChunkName: "locale__data_lang_en_KW_json" */), cache: true }],
  "en-bh": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-BH.json", load: () => import("../lang/en-BH.json" /* webpackChunkName: "locale__data_lang_en_BH_json" */), cache: true }],
  "en-qa": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-QA.json", load: () => import("../lang/en-QA.json" /* webpackChunkName: "locale__data_lang_en_QA_json" */), cache: true }],
  "en-ke": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-KE.json", load: () => import("../lang/en-KE.json" /* webpackChunkName: "locale__data_lang_en_KE_json" */), cache: true }],
  "en-ng": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__data_lang_en_json" */), cache: true },
{ key: "../lang/en-NG.json", load: () => import("../lang/en-NG.json" /* webpackChunkName: "locale__data_lang_en_NG_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "__i18n_config_ts_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "./i18n.config.ts",
  "locales": [
    {
      "code": "en",
      "language": "en",
      "iso": "en",
      "files": [
        "lang/en.json",
        "lang/en-GB.json"
      ]
    },
    {
      "code": "en-ca",
      "language": "en-CA",
      "iso": "en-CA",
      "files": [
        "lang/en.json",
        "lang/en-CA.json"
      ]
    },
    {
      "code": "en-co",
      "language": "en-CO",
      "iso": "en-CO",
      "files": [
        "lang/en.json",
        "lang/en-CO.json"
      ]
    },
    {
      "code": "es-co",
      "language": "es-CO",
      "iso": "es-CO",
      "files": [
        "lang/es.json",
        "lang/es-CO.json"
      ]
    },
    {
      "code": "en-cr",
      "language": "en-CR",
      "iso": "en-CR",
      "files": [
        "lang/en.json",
        "lang/en-CR.json"
      ]
    },
    {
      "code": "es-cr",
      "language": "es-CR",
      "iso": "es-CR",
      "files": [
        "lang/es.json",
        "lang/es-CR.json"
      ]
    },
    {
      "code": "en-es",
      "language": "en-ES",
      "iso": "en-ES",
      "files": [
        "lang/en.json",
        "lang/en-ES.json"
      ]
    },
    {
      "code": "es",
      "language": "es",
      "iso": "es",
      "files": [
        "lang/es.json"
      ]
    },
    {
      "code": "es-es",
      "language": "es-ES",
      "iso": "es-ES",
      "files": [
        "lang/es.json"
      ]
    },
    {
      "code": "en-ge",
      "language": "en-GE",
      "iso": "en-GE",
      "files": [
        "lang/en.json",
        "lang/en-GE.json"
      ]
    },
    {
      "code": "en-gb",
      "language": "en-GB",
      "iso": "en-GB",
      "files": [
        "lang/en.json",
        "lang/en-GB.json"
      ]
    },
    {
      "code": "en-us",
      "language": "en-US",
      "iso": "en-US",
      "files": [
        "lang/en.json",
        "lang/en-US.json"
      ]
    },
    {
      "code": "en-hk",
      "language": "en-HK",
      "iso": "en-HK",
      "files": [
        "lang/en.json",
        "lang/en-HK.json"
      ]
    },
    {
      "code": "en-hu",
      "language": "en-HU",
      "iso": "en-HU",
      "files": [
        "lang/en.json",
        "lang/en-HU.json"
      ]
    },
    {
      "code": "hu-hu",
      "language": "hu-HU",
      "iso": "hu-HU",
      "files": [
        "lang/hu.json"
      ]
    },
    {
      "code": "en-in",
      "language": "en-IN",
      "iso": "en-IN",
      "files": [
        "lang/en.json",
        "lang/en-IN.json"
      ]
    },
    {
      "code": "en-ie",
      "language": "en-IE",
      "iso": "en-IE",
      "files": [
        "lang/en.json",
        "lang/en-IE.json"
      ]
    },
    {
      "code": "en-au",
      "language": "en-AU",
      "iso": "en-AU",
      "files": [
        "lang/en.json",
        "lang/en-AU.json"
      ]
    },
    {
      "code": "en-pa",
      "language": "en-PA",
      "iso": "en-PA",
      "files": [
        "lang/en.json",
        "lang/en-PA.json"
      ]
    },
    {
      "code": "es-pa",
      "language": "es-PA",
      "iso": "es-PA",
      "files": [
        "lang/es.json",
        "lang/es-PA.json"
      ]
    },
    {
      "code": "en-pe",
      "language": "en-PE",
      "iso": "en-PE",
      "files": [
        "lang/en.json",
        "lang/en-PE.json"
      ]
    },
    {
      "code": "es-pe",
      "language": "es-PE",
      "iso": "es-PE",
      "files": [
        "lang/es.json",
        "lang/es-PE.json"
      ]
    },
    {
      "code": "en-pl",
      "language": "en-PL",
      "iso": "en-PL",
      "files": [
        "lang/en.json",
        "lang/en-PL.json"
      ]
    },
    {
      "code": "pl-pl",
      "language": "pl-PL",
      "iso": "pl-PL",
      "files": [
        "lang/pl.json"
      ]
    },
    {
      "code": "en-pt",
      "language": "en-PT",
      "iso": "en-PT",
      "files": [
        "lang/en.json",
        "lang/en-PT.json"
      ]
    },
    {
      "code": "pt-pt",
      "language": "pt-PT",
      "iso": "pt-PT",
      "files": [
        "lang/pt.json"
      ]
    },
    {
      "code": "en-ro",
      "language": "en-RO",
      "iso": "en-RO",
      "files": [
        "lang/en.json",
        "lang/en-RO.json"
      ]
    },
    {
      "code": "en-za",
      "language": "en-ZA",
      "iso": "en-ZA",
      "files": [
        "lang/en.json",
        "lang/en-ZA.json"
      ]
    },
    {
      "code": "en-ae",
      "language": "en-AE",
      "iso": "en-AE",
      "files": [
        "lang/en.json",
        "lang/en-AE.json"
      ]
    },
    {
      "code": "en-sa",
      "language": "en-SA",
      "iso": "en-SA",
      "files": [
        "lang/en.json",
        "lang/en-SA.json"
      ]
    },
    {
      "code": "en-om",
      "language": "en-OM",
      "iso": "en-OM",
      "files": [
        "lang/en.json",
        "lang/en-OM.json"
      ]
    },
    {
      "code": "en-kw",
      "language": "en-KW",
      "iso": "en-KW",
      "files": [
        "lang/en.json",
        "lang/en-KW.json"
      ]
    },
    {
      "code": "en-bh",
      "language": "en-BH",
      "iso": "en-BH",
      "files": [
        "lang/en.json",
        "lang/en-BH.json"
      ]
    },
    {
      "code": "en-qa",
      "language": "en-QA",
      "iso": "en-QA",
      "files": [
        "lang/en.json",
        "lang/en-QA.json"
      ]
    },
    {
      "code": "en-ke",
      "language": "en-KE",
      "iso": "en-KE",
      "files": [
        "lang/en.json",
        "lang/en-KE.json"
      ]
    },
    {
      "code": "en-ng",
      "language": "en-NG",
      "iso": "en-NG",
      "files": [
        "lang/en.json",
        "lang/en-NG.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": true,
  "langDir": "lang",
  "rootRedirect": null,
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const nuxtI18nOptionsDefault = {
  "experimental": {
    "localeDetector": ""
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [],
  "defaultLocale": "",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": null,
  "rootRedirect": null,
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false
}

export const nuxtI18nInternalOptions = {
  "__normalizedLocales": [
    {
      "code": "en",
      "language": "en",
      "iso": "en",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-GB.json"
        }
      ]
    },
    {
      "code": "en-ca",
      "language": "en-CA",
      "iso": "en-CA",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-CA.json"
        }
      ]
    },
    {
      "code": "en-co",
      "language": "en-CO",
      "iso": "en-CO",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-CO.json"
        }
      ]
    },
    {
      "code": "es-co",
      "language": "es-CO",
      "iso": "es-CO",
      "files": [
        {
          "path": "lang/es.json"
        },
        {
          "path": "lang/es-CO.json"
        }
      ]
    },
    {
      "code": "en-cr",
      "language": "en-CR",
      "iso": "en-CR",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-CR.json"
        }
      ]
    },
    {
      "code": "es-cr",
      "language": "es-CR",
      "iso": "es-CR",
      "files": [
        {
          "path": "lang/es.json"
        },
        {
          "path": "lang/es-CR.json"
        }
      ]
    },
    {
      "code": "en-es",
      "language": "en-ES",
      "iso": "en-ES",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-ES.json"
        }
      ]
    },
    {
      "code": "es",
      "language": "es",
      "iso": "es",
      "files": [
        {
          "path": "lang/es.json"
        }
      ]
    },
    {
      "code": "es-es",
      "language": "es-ES",
      "iso": "es-ES",
      "files": [
        {
          "path": "lang/es.json"
        }
      ]
    },
    {
      "code": "en-ge",
      "language": "en-GE",
      "iso": "en-GE",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-GE.json"
        }
      ]
    },
    {
      "code": "en-gb",
      "language": "en-GB",
      "iso": "en-GB",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-GB.json"
        }
      ]
    },
    {
      "code": "en-us",
      "language": "en-US",
      "iso": "en-US",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-US.json"
        }
      ]
    },
    {
      "code": "en-hk",
      "language": "en-HK",
      "iso": "en-HK",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-HK.json"
        }
      ]
    },
    {
      "code": "en-hu",
      "language": "en-HU",
      "iso": "en-HU",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-HU.json"
        }
      ]
    },
    {
      "code": "hu-hu",
      "language": "hu-HU",
      "iso": "hu-HU",
      "files": [
        {
          "path": "lang/hu.json"
        }
      ]
    },
    {
      "code": "en-in",
      "language": "en-IN",
      "iso": "en-IN",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-IN.json"
        }
      ]
    },
    {
      "code": "en-ie",
      "language": "en-IE",
      "iso": "en-IE",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-IE.json"
        }
      ]
    },
    {
      "code": "en-au",
      "language": "en-AU",
      "iso": "en-AU",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-AU.json"
        }
      ]
    },
    {
      "code": "en-pa",
      "language": "en-PA",
      "iso": "en-PA",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-PA.json"
        }
      ]
    },
    {
      "code": "es-pa",
      "language": "es-PA",
      "iso": "es-PA",
      "files": [
        {
          "path": "lang/es.json"
        },
        {
          "path": "lang/es-PA.json"
        }
      ]
    },
    {
      "code": "en-pe",
      "language": "en-PE",
      "iso": "en-PE",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-PE.json"
        }
      ]
    },
    {
      "code": "es-pe",
      "language": "es-PE",
      "iso": "es-PE",
      "files": [
        {
          "path": "lang/es.json"
        },
        {
          "path": "lang/es-PE.json"
        }
      ]
    },
    {
      "code": "en-pl",
      "language": "en-PL",
      "iso": "en-PL",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-PL.json"
        }
      ]
    },
    {
      "code": "pl-pl",
      "language": "pl-PL",
      "iso": "pl-PL",
      "files": [
        {
          "path": "lang/pl.json"
        }
      ]
    },
    {
      "code": "en-pt",
      "language": "en-PT",
      "iso": "en-PT",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-PT.json"
        }
      ]
    },
    {
      "code": "pt-pt",
      "language": "pt-PT",
      "iso": "pt-PT",
      "files": [
        {
          "path": "lang/pt.json"
        }
      ]
    },
    {
      "code": "en-ro",
      "language": "en-RO",
      "iso": "en-RO",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-RO.json"
        }
      ]
    },
    {
      "code": "en-za",
      "language": "en-ZA",
      "iso": "en-ZA",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-ZA.json"
        }
      ]
    },
    {
      "code": "en-ae",
      "language": "en-AE",
      "iso": "en-AE",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-AE.json"
        }
      ]
    },
    {
      "code": "en-sa",
      "language": "en-SA",
      "iso": "en-SA",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-SA.json"
        }
      ]
    },
    {
      "code": "en-om",
      "language": "en-OM",
      "iso": "en-OM",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-OM.json"
        }
      ]
    },
    {
      "code": "en-kw",
      "language": "en-KW",
      "iso": "en-KW",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-KW.json"
        }
      ]
    },
    {
      "code": "en-bh",
      "language": "en-BH",
      "iso": "en-BH",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-BH.json"
        }
      ]
    },
    {
      "code": "en-qa",
      "language": "en-QA",
      "iso": "en-QA",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-QA.json"
        }
      ]
    },
    {
      "code": "en-ke",
      "language": "en-KE",
      "iso": "en-KE",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-KE.json"
        }
      ]
    },
    {
      "code": "en-ng",
      "language": "en-NG",
      "iso": "en-NG",
      "files": [
        {
          "path": "lang/en.json"
        },
        {
          "path": "lang/en-NG.json"
        }
      ]
    }
  ]
}

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

